import React, { useEffect } from "react";
import { useQuery } from "react-query";
import {
  coinGetMe,
  getRoom,
  getTicketDetailById,
  tokenGetMe,
} from "../services/game.service";
import GameItem from "../components/items/GameItem";
import PopUpUseTicketL2 from "../components/popup/PopUpUseTicketL2";
import PopUpUseTicket from "../components/popup/PopUpUseTicket";
import { useNavigate, useParams } from "react-router-dom";
import PopUpRewardPoint from "../components/popup/PopUpRewardPoint";
import PopUpUseTicketL3 from "../components/popup/PopUpUseTicketL3";
import PopUpUseTicketL4 from "../components/popup/PopUpUseTicketL4";
import BannerComponent from "../game/components/BannerComponent";
import PopUpRewardLoss from "../components/popup/PopUpRewardLoss";

type Props = {};

export default function GameV2Select() {
  const navigate = useNavigate(); //
  const { ticketId } = useParams();
  const [popup, setPopup] = React.useState<any>({});
  // const {} = useQuery();

  // call useQuery without assigning unused vars (use services read token from sessionStorage)
  useQuery(["get-room-data"], async () => {
    // getRoom() reads token from sessionStorage if not provided; you can also pass { token }
    return await getRoom();
  });
  const { data: ticketDetail } = useQuery(
    ["get-ticket-detail", ticketId],
    async () => {
      // getTicketDetailById() will read token from sessionStorage if not provided
      return await getTicketDetailById({ ticketId: ticketId as string });
    },
    {
      enabled: !!ticketId && ticketId != "undifined",
      onError: (error: any) => {
        const status = error?.response?.status ?? error?.status;
        if (status === 404) {
          // redirect to home if ticket not found
          navigate("/buy-ticket", { replace: true });
        }
      },
      onSuccess: (data) => {
        if (Object.keys(popup).length === 0) {
          if (data?.isUsed || data?.isExpired || data?.isActive == false) {
            navigate("/buy-ticket", { replace: true });
          }
        }
      },
    }
  );
  const { data: tokenMe } = useQuery(["get-token-me"], async () => {
    // getTokenMe() reads token from sessionStorage if not provided
    const res = await tokenGetMe({});
    return res;
  });
  const { data: coinMe } = useQuery(["get-coin-me"], async () => {
    // getCoinMe() reads token from sessionStorage if not provided
    const res = await coinGetMe({});
    return res;
  });

  useEffect(() => {
    if (ticketId == "undifined") {
      setTimeout(() => {
        setPopup({
          PopUpRewardLoss: "0",
        });
      }, 5000);
    }
  }, [ticketId]);

  if (!ticketId) {
    return null;
  }

  return (
    <>
      <div className="relative p-4 overflow-auto h-full">
        <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-50 pointer-events-none" />
        <div className="w-full mb-4 relative">
          <GameItem width={"100%"} itemKey={"header"} />
          <div
            onClick={() => {
              try {
                const data = {
                  action: "close",
                  reason: "user_clicked_button",
                };

                (window as any).ReactNativeWebView.postMessage(
                  JSON.stringify(data)
                );
              } catch (e) {
                console.log("Not in RN WebView");
              }
            }}
            className="absolute top-[4%] left-[2%] bg-transparent w-[15%] aspect-square font-bold text-[24px] cursor-pointer"
          ></div>
        </div>

        {/* token & point */}
        <div className="grid grid-cols-[1fr_1fr_1fr] w-full max-h-[38px] h-[38px] mb-4 relative">
          <div
            style={{
              aspectRatio: "83 / 31",
              overflow: "hidden",
              height: "100%",
              position: "relative",
            }}
            onClick={() => {
              try {
                const data = {
                  action: "go_to_token_shop",
                  reason: "user_clicked_button",
                };

                (window as any).ReactNativeWebView.postMessage(
                  JSON.stringify(data)
                );
              } catch (e) {
                console.log("Not in RN WebView");
              }
            }}
          >
            <img
              src="/images/token_box.png"
              alt="spend-point"
              style={{
                height: "100%",
                width: "auto",
                // Force GPU compositing on Android
                transform: "translate3d(0,0,0)",
                WebkitTransform: "translate3d(0,0,0)",
                willChange: "transform",
              }}
            />
            <div
              style={{
                position: "absolute",
                left: 37,
                top: 7,
                fontSize: "18px",
                fontWeight: 700,
                color: "#fff",
              }}
            >
              {(tokenMe?.tokenBalance || 0).toLocaleString()}
            </div>
          </div>
          <div
            style={{
              aspectRatio: "100 / 25",
              overflow: "hidden",
              height: "100%",
              position: "relative",
            }}
          >
            <img
              src="/images/point_box.png"
              alt="spend-point"
              style={{
                height: "100%",
                width: "auto",
                // Force GPU compositing on Android
                transform: "translate3d(0,0,0)",
                WebkitTransform: "translate3d(0,0,0)",
                willChange: "transform",
              }}
            />
            <div
              style={{
                position: "absolute",
                left: 37,
                top: 7,
                fontSize: "18px",
                fontWeight: 700,
                color: "#fff",
              }}
            >
              {(coinMe?.coinBalance || 0).toLocaleString()}
            </div>
          </div>
          <div className="absolute bottom-0 right-0">
            <div
              className="grid"
              style={{
                width: "60px",
                height: "auto",
                justifyItems: "center",
                alignItems: "center",
              }}
              onClick={() => {
                try {
                  const data = {
                    action: "go_to_shop",
                    reason: "user_clicked_button",
                  };

                  (window as any).ReactNativeWebView.postMessage(
                    JSON.stringify(data)
                  );
                } catch (e) {
                  console.log("Not in RN WebView");
                }
              }}
            >
              <img
                src="/images/go2spendPoint.png"
                alt="spend-point"
                style={{
                  width: "100%",
                  aspectRatio: "176 / 200",
                  // Force GPU compositing on Android
                  transform: "translate3d(0,0,0)",
                  WebkitTransform: "translate3d(0,0,0)",
                  willChange: "transform",
                }}
              />
            </div>
          </div>
        </div>

        {/* banner */}
        <div className="w-full mb-4">
          <BannerComponent />
        </div>

        {/* button */}
        {/* <div className="w-full flex justify-center items-center mb-4 z-10 relative">
          <div className="w-[200px]">
            <GameItem width={"100%"} itemKey={"buyTicketButton"} />
          </div>
        </div> */}

        {/* card */}
        <div className="p-2 bg-[#ffffff]/60 mb-4 rounded-xl relative">
          <div className="grid grid-cols-6 gap-2">
            {[...Array(6)].map((_, idx) => (
              <div
                className={
                  ticketDetail?.ticketLevel == "L4" ? "z-50 relative" : ""
                }
                onClick={() => {
                  if (ticketDetail?.ticketLevel == "L4") {
                    setPopup({ PopUpUseTicketL4: ticketDetail?._id });
                  }
                }}
              >
                <GameItem key={idx} width={"100%"} itemKey={"l4card"} />
              </div>
            ))}
          </div>
        </div>
        {/* data */}
        <div className="bg-[#ffffff]/60 mb-4 rounded-xl">
          <div
            className={`p-2 z-50 ${
              ticketDetail?.ticketLevel == "L3" ? "z-50 relative" : ""
            }`}
          >
            <div className="relative">
              <div
                className="grid grid-cols-8 "
                style={{
                  transform: "translateY(50%)",
                  paddingBottom: "50px",
                }}
              >
                {[...Array(16)].map((_, idx) => (
                  <div className="relative w-full aspect-[2/1] grid grid-cols-1">
                    <div
                      className={`relative -mt-[50px] w-full flex justify-center items-center`}
                      style={{
                        zIndex: 1000 - idx,
                      }}
                      onClick={() => {
                        if (ticketDetail?.ticketLevel == "L3") {
                          setPopup({ PopUpUseTicketL3: ticketDetail?._id });
                        }
                      }}
                    >
                      <GameItem key={idx} width={"100%"} itemKey={"l3card"} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {/* data */}
        <div
          className="grid grid-cols-2 gap-2 bg-[#ffffff]/60 rounded-xl"
          style={{
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            gap: "10px",
            padding: "10px",
            paddingTop: "8%",
            rowGap: "12%",
            paddingBottom: "22%",
          }}
        >
          {["property", "money_bag", "car", "money", "crown", "gift"].map(
            (itemKey, index) => {
              const isMatch =
                ticketDetail?.ticketLevel == "L2" &&
                itemKey == ticketDetail?.lv2Type;
              return (
                <div
                  key={index}
                  className={isMatch ? "z-50" : "z-10"}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                    width: "100%",
                    gap: "2px",
                  }}
                >
                  {[...Array(16)].map((_, idx) => (
                    <div
                      key={idx}
                      style={{
                        aspectRatio: "2 / 1",
                        position: "relative",
                        zIndex: 1000 - idx,
                      }}
                    >
                      <div
                        role={isMatch ? "button" : undefined}
                        tabIndex={isMatch ? 0 : undefined}
                        onClick={() => {
                          if (isMatch) {
                            const billId =
                              ticketDetail?.billId ?? ticketDetail?._id;
                            if (billId)
                              setPopup({
                                PopUpUseTicketL2: ticketDetail?._id,
                              });
                          }
                        }}
                        style={{
                          position: "absolute",
                          aspectRatio: "1 / 1",
                          bottom: 0,
                          width: "100%",
                          left: 0,
                          right: 0,
                          margin: "auto",
                          cursor: isMatch ? "pointer" : "default",
                        }}
                      >
                        <div className="relative w-full h-full flex justify-center items-center">
                          <GameItem
                            width={"100%"}
                            height={"100%"}
                            itemKey={itemKey}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              );
            }
          )}
        </div>
        <div className="h-[100px]" />
      </div>
      {/* popup: L2 open */}
      <PopUpUseTicketL2
        open={!!popup.PopUpUseTicketL2}
        ticketId={popup.PopUpUseTicketL2}
        onStartOpen={(ticketIds: any) => {
          const getTicketId = ticketIds.find(
            (t: any) => t.ticketLevel == "L1" && !t?.isUsed && !t?.isExpired
          );
          if (getTicketId) {
            setPopup({ PopUpUseTicket: getTicketId._id });
          } else {
            setPopup({});
          }
        }}
        callbackData={(data) => {
          if (data?.ticketDoc?.result_lv2?.value === "POINT") {
            setPopup({
              PopUpRewardPoint: (
                data?.ticketDoc?.result_lv2?.pointAmount || 0
              ).toLocaleString(),
            });
          } else if (
            data?.ticketDoc?.result_lv2?.value === "RESULT_NOT_MATCH"
          ) {
            setTimeout(() => {
              navigate("/buy-ticket", { replace: true });
            }, 2000);
          } else if (
            data?.ticketDoc?.result_lv2?.value === "FREE_ADDITIONAL_CATCH"
          ) {
            setTimeout(() => {
              navigate(
                `/game2/select/${data?.ticketDoc?.result_lv2?.ticketId}`,
                { replace: true }
              );
              setPopup({});
            }, 2000);
          } else if (data?.ticketDoc?.result_lv2?.value === "RESULT_MATCH") {
            setTimeout(() => {
              navigate(
                `/game2/select/${data?.ticketDoc?.result_lv2?.ticketId}`,
                { replace: true }
              );
              setPopup({});
            }, 2000);
          }
        }}
        onClose={() => setPopup({})}
      />
      <PopUpUseTicketL3
        open={!!popup.PopUpUseTicketL3}
        ticketId={popup.PopUpUseTicketL3}
        onStartOpen={(ticketIds: any) => {
          const getTicketId = ticketIds.find(
            (t: any) => t.ticketLevel == "L1" && !t?.isUsed && !t?.isExpired
          );
          if (getTicketId) {
            setPopup({ PopUpUseTicket: getTicketId._id });
          } else {
            setPopup({});
          }
        }}
        callbackData={(data) => {
          if (data?.ticketDoc?.result_lv3?.value === "POINT") {
            setPopup({
              PopUpRewardPoint: (
                data?.ticketDoc?.result_lv3?.pointAmount || 0
              ).toLocaleString(),
            });
          } else if (
            data?.ticketDoc?.result_lv3?.value === "RESULT_NOT_MATCH"
          ) {
            // setTimeout(() => {
            //   navigate("/buy-ticket", { replace: true });
            // }, 2000);
            setTimeout(() => {
              // setCloseButtonVisible(true);
              navigate(`/game2/select/undifined`, {
                replace: false,
              });
            }, 2000);
          } else if (data?.ticketDoc?.result_lv3?.value === "RESULT_MATCH") {
            setTimeout(() => {
              navigate(
                `/game2/select/${data?.ticketDoc?.result_lv3?.ticketId}`,
                { replace: true }
              );
              setPopup({});
            }, 2000);
          }
        }}
        onClose={() => setPopup({})}
      />
      <PopUpUseTicketL4
        open={!!popup.PopUpUseTicketL4}
        ticketId={popup.PopUpUseTicketL4}
        callbackData={(data) => {
          if (data?.ticketDoc?.result_lv4?.value === "POINT") {
            setPopup({
              PopUpRewardPoint: (
                data?.ticketDoc?.result_lv4?.pointAmount || 0
              ).toLocaleString(),
            });
          } else if (
            data?.ticketDoc?.result_lv4?.value === "RESULT_NOT_MATCH"
          ) {
            // setTimeout(() => {
            //   navigate("/buy-ticket", { replace: true });
            // }, 2000);
            setTimeout(() => {
              // setCloseButtonVisible(true);
              navigate(`/game2/select/undifined`, {
                replace: false,
              });
            }, 2000);
          } else if (data?.ticketDoc?.result_lv4?.value === "RESULT_MATCH") {
            setTimeout(() => {
              navigate(
                `/game2/select/${data?.ticketDoc?.result_lv4?.ticketId}`,
                { replace: true }
              );
              setPopup({});
            }, 2000);
          }
        }}
        onClose={() => setPopup({})}
      />

      <PopUpRewardLoss
        open={!!popup.PopUpRewardLoss}
        rewardAmount={popup.PopUpRewardLoss || "0"}
        onClose={() => {
          setPopup({});
          navigate("/buy-ticket", { replace: true });
        }}
      />

      <PopUpRewardPoint
        open={!!popup.PopUpRewardPoint}
        rewardAmount={popup.PopUpRewardPoint || "0"}
        onClose={() => {
          setPopup({});
          navigate("/buy-ticket", { replace: true });
        }}
      />
    </>
  );
}
